module.exports = __webpack_public_path__ + "static/img/qualification3.7806e3e6.png";